import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Gauge, X } from '../ui/Icon';

interface Props {
  resetsAt?: string | null;
}

/**
 * The map tiles still load once the monthly cap is spent — what stops is
 * everything we proxy: searching places, venue details, routes. Says so on top
 * of the map, because the alternative is a map where nothing happens when you
 * click and no explanation anywhere.
 */
export default function MapQuotaBanner({ resetsAt }: Props) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  const date = resetsAt ? new Date(resetsAt).toLocaleDateString() : null;

  return (
    <div className="absolute top-3 left-1/2 -translate-x-1/2 z-30 max-w-[min(28rem,calc(100%-1.5rem))]">
      <div className="flex items-start gap-2.5 pl-3 pr-2 py-2.5 rounded-xl bg-amber-50/95 dark:bg-amber-950/90 backdrop-blur border border-amber-200 dark:border-amber-900 shadow-lg">
        <Icon as={Gauge} size={15} className="text-amber-500 shrink-0 mt-0.5" />
        <div className="min-w-0">
          <p className="text-xs font-semibold text-amber-900 dark:text-amber-200">{t('map.quota.title')}</p>
          <p className="text-[11px] text-amber-800/80 dark:text-amber-300/80 leading-snug">
            {date ? t('map.quota.bodyWithDate', { date }) : t('map.quota.body')}
          </p>
        </div>
        <button
          onClick={() => setDismissed(true)}
          aria-label={t('common.close')}
          className="shrink-0 w-6 h-6 rounded-lg flex items-center justify-center text-amber-500 hover:bg-amber-100 dark:hover:bg-amber-900/50 transition-colors cursor-pointer"
        >
          <Icon as={X} size={13} />
        </button>
      </div>
    </div>
  );
}
